import { EHttpMethods } from "../../../../enums";
import { AUTH_BASE_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IPhoneRuleConfigsResponse } from "./models";

// Web-next calls this with the app (client) token; the portal never obtains one, so it goes
// out with the signed-in user's token instead.
const defaultProvide = async () => await getToken();

export const getPhoneRuleConfigs = (): Promise<IPhoneRuleConfigsResponse> => {
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}/api/phone-rule-configs`,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};
